import {App} from './App';

const app = new App();

app.Run();

// Display version and build date in the footer
const versionElement = document.getElementById('version-info');
if (versionElement) {
    const buildDate = new Date(__BUILD_DATE__);
    const formattedDate = buildDate.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
    versionElement.textContent = `Version ${__APP_VERSION__} | Build: ${formattedDate}`;
}